import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LeadDTO } from 'src/app/core/models/lead.model';
import { SalesRepService } from 'src/app/core/services/sales-rep.service';
import { SalesRep } from 'src/app/core/models/sales-rep.model';
import { LeadStatus } from 'src/app/core/models/leadStatus.model';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-lead-modal',
  templateUrl: './lead-modal.component.html',
  styleUrls: ['./lead-modal.component.scss']
})
export class LeadModalComponent implements OnInit {
  @Input() lead: LeadDTO | null = null;
  @Output() save = new EventEmitter<LeadDTO>();
  @Output() close = new EventEmitter<void>();

  leadForm: FormGroup;
  salesReps: SalesRep[] = [];
  editMode: boolean = false;
  leadStatuses: string[] = [];

  constructor(
    private fb: FormBuilder,
    private salesRepService: SalesRepService,
    private cdr: ChangeDetectorRef
  ) {
    this.leadForm = this.fb.group({
      businessName: [''],
      contactName: [''],
      contactNumber: [''],
      contactEmail: [''],
      status: [''],
      interestedMachineCount: [0],
      closedMachineCount: [0],
      expectedDeliveryDate: [''],
      assignedSalesRepId: ['']
    });
  }
async ngOnInit(): Promise<void> {
  this.leadStatuses = Object.values(LeadStatus);

  try {
    const allReps = await this.salesRepService.getAll();
    this.salesReps = allReps.filter(rep => rep.enabled);
  } catch (err) {
    console.error('Failed to load sales reps:', err);
  }

if (this.lead) {
  this.editMode = true;

  const digitsOnly = this.lead.contactNumber?.replace(/\D/g, '') || '';
  const tenDigits = digitsOnly.slice(-10); // last 10 digits for formatting
  const formattedPhone = tenDigits ? `(${tenDigits.slice(0,3)}) ${tenDigits.slice(3,6)}-${tenDigits.slice(6)}` : '';

  this.leadForm.patchValue({
    ...this.lead,
    contactNumber: formattedPhone
  });
}

  this.cdr.detectChanges();
}


onSubmit(): void {
  if (!this.leadForm.valid) {
    console.warn('Form is invalid');
    return;
  }

  const formValue = this.leadForm.value;

  // Handle potential "new rep" option
  const repId = formValue.assignedSalesRepId;
  const assignedSalesRepId = repId === 'new-rep' ? null : repId;

  // Extract only digits from the input and reformat with +1
  const rawPhone = formValue.contactNumber?.replace(/\D/g, '') || '';
  const formattedPhone = rawPhone ? `+1${rawPhone}` : '';

  const payload = this.lead?.id
    ? { ...formValue, contactNumber: formattedPhone, assignedSalesRepId, id: this.lead.id }
    : { ...formValue, contactNumber: formattedPhone, assignedSalesRepId };

  console.log('Form Submitted', payload);
  this.save.emit(payload);

  this.onClose();
}



  onClose(): void {
    this.leadForm.reset();
    this.close.emit();
  }

  formatRepName(rep: SalesRep): string {
    const fullName = [rep.firstName, rep.lastName].filter(Boolean).join(' ');
    return fullName || rep.username || rep.id;
  }
}
